<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10QM1eF/tc-custom/9781398471795.jpg?1705540767791" alt="This image is the cover for the book Time Heal My Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Time Heal My Heart
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1914 young husbands and sons set off in high spirits for the grand adventure of war, a war promised to be over by Christmas. Little do they or their loved ones realise that four long years of horror lay ahead. The First World War shatters the peaceful lives of newlywed Australian immigrants, Walter and Winifred. Their families lie over the ocean in England, their brothers fight on the battlefields of Europe. Torn by loyalties, they set off on a perilous sea journey during wartime, shortly after the sinking of the Lusitania by German U-boats. But their neighbour, Lisbette, a girl with a mysterious past, must stay to live in anguish in Australia, unable to return to her native France. The scene shifts from Australia to Gallipoli and the battlefields of Flanders, culminating at the mystical Mont-Saint-Michel off the Normandy coast. Here, Effie, one of many tiny victims of the war, finds refuge in the centuries-old monastery. It is all a matter of time. Will authorities find Effie’s parents at the war’s end? How long can Winifred’s brother, Gustave, survive the trenches? And can returning soldiers escape the deadly grip of the Spanish flu? Whether read as a stand-alone novel or sequel to Whispers Through Time, this drama will tear at your heartstrings, especially as it is based on a true story.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joni Scott
      </h2>
      
      <p class="authorDescription body article">Joni Scott had a scientific career as an organic chemist and biochemist in hospitals and industry. She also home-schooled her children and embarked on another career running a tutoring business. After writing her debut novel, Whispers Through Time, she contracted CRPS and lost the use of her dominant right arm and hand. In early 2020, she travelled to Italy for treatment but ended up in lockdown. This experience inspired her second novel, The Last Hotel which she wrote with her left hand. Though the physical act of writing is still a struggle, Joni is determined to continue. Time Heal My Heart is her third novel and can be read as a free-standing novel or sequel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b25e8b7a